<template>
  <Spinner v-if="userStore.isLoading" />
  <Navbar />
  <div id="bst-wrap">
    <div class="l-project-wrap l-project-wrap--mypage">

      <Header />

      <section class="l-content-area">
        <div class="l-content">

          <!-- MYPAGE -->
          <section class="p-bloc p-bloc--mypage">
            <div class="p-bloc__content l-wrap__outer">
              <div class="l-wrap__inner">

                <section class="p-mypage">

                  <!-- Mypage Menu -->
                  <NavbarMyPage />

                  <!-- Side Menu -->
                  <SideMenu />

                  <!-- Mypage Content -->
                  <div class="p-mypage__content">
                    <div class="mypage-content">

                      <!-- account -->
                      <div class="p-mypage__account p-mypage__account--profile mypage-bloc">
                        <div class="mypage-bloc__head">
                          <h2>{{ $t("LABEL_ACCOUNT_INFO") }}</h2>
                          <div class="mypage-bloc__btn">
                            <button id="edit-profile"
                              class="bloc__act-btn bloc__act-btn--profile-edit"><span>{{ $t("LABEL_EDIT")
                                }}</span><img src="@/assets/img/ui_parts/svg/bloc_btn_edit.svg"
                                :alt="$t('LABEL_EDIT')" /></button>
                          </div>
                        </div>
                        <div class="mypage-bloc__content">
                          <!-- User Profile -->
                          <Profile />

                          <!-- edit -->
                          <EditProfile />
                        </div>
                      </div>

                      <EmailInfo />

                      <!-- password -->
                      <PasswordReset/>

                      <!-- delete -->
                      <DeleteUser/>

                    </div><!-- .mypage-content -->
                  </div>

                </section>

              </div>
            </div>
          </section>


        </div><!-- .l-content -->
      </section><!-- .l-content-area -->

    </div><!-- .l-project-wrap -->


    <div class="l-modal-wrap">

      <!-- modal - reminder -->
      <div id="modal-reminder" class="l-modal">
        <div class="l-modal__bg">
          <div class="l-modal__inner">
            <div class="l-modal__window l-modal__window--reminder">

              <div class="p-modal-reminder">
                <div class="p-modal-reminder__title">
                  <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                  <h1>{{ $t("TITLE_REMINDER_PAGE") }}</h1>
                </div>

                <section class="p-modal-reminder__sender">
                  <p v-html="$t('TEXT_REMINDER_PAGE')"></p>
                  <dl class="mailaddress">
                    <dt>{{ $t("LABEL_EMAIL") }}</dt>
                    <dd>{{ userStore.accountUpdateParams.email }}</dd>
                  </dl>
                  <div class="c-btn c-btn--modal-reminder"><input id="btn-confirm-reminder" type="button" v-on:click="sendResetPasswordRequest()"
                      :value="$t('LABEL_BUTTON_SEND_REMINDER')"></div>
                  <div class="c-btn c-btn--modal-reminder-back modal-close"><a href="#">{{ $t("LABEL_RETURN") }}</a>
                  </div>
                </section>

                <section class="p-modal-reminder__finish" style="display: none;">
                  <p v-html="$t('TEXT_REMINDER_COMPLETE')"></p>
                  <p v-html="$t('TEXT_REMINDER_COMPLETE_1')"> </p>
                  <div class="c-btn c-btn--modal-reminder-back modal-close"><a id="btn-reminder-complete-return" href="#">{{ $t("LABEL_RETURN") }}</a>
                  </div>
                </section>
              </div><!-- .p-modal-reminder -->

            </div>
          </div>
        </div>
      </div>

      <!-- modal - delete account -->
      <div id="modal-delete" class="l-modal">
        <div class="l-modal__bg">
          <div class="l-modal__inner">
            <div class="l-modal__window l-modal__window--delete">

              <div class="p-modal-delete">
                <h2>{{ $t("LABEL_DELETE_ACCOUNT") }}</h2>
                <div class="attention"><img src="@/assets/img/ui_parts/svg/attention_icon_tri.svg" alt="！"></div>
                <p v-html="$t('TEXT_RESIGN_WARNING_MODAL')"></p>
                <ul class="p-modal-delet__btn">
                  <li class="c-btn c-btn--modal-delete-back modal-close"><a href="#">{{ $t("LABEL_CANCEL") }}</a></li>
                  <li class="c-btn c-btn--modal-delete"><button id="btn-confirm-delete-account" v-on:click="deleteUser()">{{ $t("LABEL_COMPLETE_DELETE_ACCOUNT") }}</button></li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- modal - mailaddress -->
      <div id="modal-mailaddress" class="l-modal">
            <div class="l-modal__bg">
                <div class="l-modal__inner">
                    <div class="l-modal__window l-modal__window--mailaddress">

                        <div class="p-modal-mailaddress">
                            <div class="p-modal-mailaddress__title">
                                <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                                <h1>{{ $t('LABEL_CHANGE_MAIL_ADDRESS') }}</h1>
                            </div>

                            <section class="p-modal-mailaddress__sender c-form-parts">
                                <p v-html="$t('TEXT_EDIT_USER_1')"></p>
                                <dl class="mailaddress">
                                    <dt>{{ $t('LABEL_EMAIL') }}<span>＊</span></dt>
                                    <dd>
                                        <div class="input-area" :class="{ 'is-error': v$.email.$error || userStore.emailChangeRequestErrors.email || userStore.emailChangeRequestErrorMsg }"><!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                                            <input type="email" name="email" class="plchldr" :placeholder="$t('LABEL_NEW_EMAIL')" v-model="userStore.emailChangeRequestParams.email">
                                        </div>
                                        <p class="error-txt" v-if="v$.email.$error">{{ $t(v$.email.$errors[0].$message) }}</p>
                                        <p class="error-txt" v-if="userStore.emailChangeRequestErrorMsg">{{ userStore.emailChangeRequestErrorMsg }}</p>
                                    </dd>
                                </dl>
                                <div class="c-btn c-btn--modal-mailaddress"><input type="button" @click="sendAuthCode()" :value="$t('LABEL_SEND_CONFIRMATION_CODE')"></div>
                                <div class="c-btn c-btn--modal-mailaddress-close modal-close"><a href="#">{{ $t('LABEL_RETURN') }}</a></div>
                            </section>

                            <section class="p-modal-mailaddress__authcode c-form-parts" style="display: none;">
                                <p>{{ $t('LABEL_INSERT_CONFIRMATION_CODE') }}</p>
                                <div class="authcode">
                                    <div class="authcode-area" :class="{ 'is-error': userStore.emailChangeErrors.email || userStore.emailChangeErrors.message || userStore.emailChangeErrorMsg }">
                                      <input v-for="(code, idx) in 6" :key="idx" type="text" class="authcode-char" maxlength="1" autocomplete="new-password"
                                        :ref="el => authCodeInputs[idx] = el" 
                                        v-model="authCode[idx]"
                                        @focus="handleFocus(idx)"
                                        @keydown="handleKeydown($event, idx)"
                                        @input="handleInput($event, idx)"
                                        @paste="handlePaste($event)"
                                      >
                                    </div>
                                    <p class="error-txt" v-if="userStore.emailChangeErrors || userStore.emailChangeErrorMsg">{{ userStore.emailChangeErrorMsg ? userStore.emailChangeErrorMsg : $t('ERROR_WRONG_CONFIRMATION_CODE') }}</p>

                                </div>
                                <!--                                <div class="c-btn c-btn&#45;&#45;modal-mailaddress-again">-->
                                <!--                                    <input type="button" value="新しいコードを取得">-->
                                <!--                                    <p class="txt-sent">認証コードを送信しました</p>-->
                                <!--                                </div>-->
                                <div class="c-btn c-btn--modal-mailaddress-back"><a href="#">{{ $t('LABEL_RETURN') }}</a></div>

                                <!-- TODO: .is-loading -->
                                <div class="c-loader p-authcode-check__loading"><span class="c-loader__icon"></span></div>
                            </section>

                            <section class="p-modal-mailaddress__finish" style="display: none;">
                                <!-- TODO: Changes Complete. -->
                                <div class="completed completed--success">
                                    <div class="complete-icon"><img src="@/assets/img/ui_parts/svg/complete_icon_success.svg" alt="完了"></div>
                                    <h2>{{ $t('TEXT_EDIT_USER_COMPLETED_1') }}</h2>
                                    <p v-html="$t('TEXT_EDIT_USER_COMPLETED_2')"></p>
                                </div>

                                <!-- TODO: If it fails with an error, this will be displayed. -->
                                <!-- <div class="completed completed--failure">
                                  <div class="complete-icon"><img src="../img/ui_parts/svg/complete_icon_failure.svg" alt="エラー"></div>
                                  <h2>エラーが発生しました</h2>
                                  <p>お手数ですがあらためて<br>変更のお手続きをお試しください。</p>
                                </div> -->

                                <div class="c-btn c-btn--modal-mailaddress-close modal-close"><a href="#">{{ $t('LABEL_CLOSE') }}</a></div>
                            </section>
                        </div><!-- .p-modal-mailaddress -->

                    </div>
                </div>
            </div>
        </div>

    </div><!-- .l-modal-wrap -->

    <Footer />

  </div>
</template>

<script setup>
import NavbarMyPage from "@/components/NavbarMyPage.vue";
import SideMenu from "@/components/SideMenu.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Profile from "@/components/Profile.vue";
import EditProfile from "@/components/EditProfile.vue";
import PasswordReset from "@/components/PasswordReset.vue";
import DeleteUser from "@/components/DeleteUser.vue";
import { onMounted } from "vue";
import { useUserStore } from "@/stores/userStore";
import { useResetPasswordStore } from "@/stores/resetPasswordStore";
import { useSessionStore } from "@/stores/sessionStore";
import Navbar from "@/components/Navbar.vue";
import Spinner from "@/components/Spinner.vue";
import EmailInfo from "@/components/EmailInfo.vue";
import {useVuelidate} from "@vuelidate/core";
import {helpers, maxLength, minLength, required} from "@vuelidate/validators";
import {isValidEmail} from "@/validations/common";

import { ref, nextTick } from "vue";
const userStore = useUserStore();
const resetPasswordStore = useResetPasswordStore();
const sessionStore = useSessionStore();

// Auth code input logic
const authCode = ref([
    userStore.emailChangeParams.code_1 || '',
    userStore.emailChangeParams.code_2 || '',
    userStore.emailChangeParams.code_3 || '',
    userStore.emailChangeParams.code_4 || '',
    userStore.emailChangeParams.code_5 || '',
    userStore.emailChangeParams.code_6 || ''
]);
const authCodeInputs = [];

function updateStoreAuthCode() {
    userStore.emailChangeParams.code_1 = authCode.value[0] || '';
    userStore.emailChangeParams.code_2 = authCode.value[1] || '';
    userStore.emailChangeParams.code_3 = authCode.value[2] || '';
    userStore.emailChangeParams.code_4 = authCode.value[3] || '';
    userStore.emailChangeParams.code_5 = authCode.value[4] || '';
    userStore.emailChangeParams.code_6 = authCode.value[5] || '';
    userStore.getEmailChangeParams.auth_code = authCode.value.join('');
}

function handleInput(e, idx) {
    const val = e.target.value;
    if (val.length > 1) {
    // If user pastes or types more than one char, only take the first
        authCode.value[idx] = val[0];
    }
    updateStoreAuthCode();
    // Move to next input if not last and value entered
    if (val && idx < 5) {
        nextTick(() => authCodeInputs[idx + 1]?.focus());
    }
    // If all filled, trigger verify
    if (authCode.value.every(c => c.length === 1)) {
        verifyAuthCode();
    }
}

function handlePaste(e) {
    const paste = (e.clipboardData || window.clipboardData).getData('text');
    if (!paste) return;
    e.preventDefault();
    const chars = paste.replace(/\s/g, '').split('').slice(0, 6);
    chars.forEach((ch, i) => {
        authCode.value[i] = ch;
    });
    updateStoreAuthCode();
    nextTick(() => {
        const nextIdx = chars.length < 6 ? chars.length : 5;
        authCodeInputs[nextIdx]?.focus();
        if (chars.length === 6) verifyAuthCode();
    });
}

function handleFocus(idx) {
    // Auto-select content on focus
    nextTick(() => {
        const input = authCodeInputs[idx];
        if (input) input.select();
    });
}

function handleKeydown(e, idx) {
    if (e.key === 'ArrowLeft' && idx > 0) {
        e.preventDefault();
        nextTick(() => authCodeInputs[idx - 1]?.focus());
    } else if (e.key === 'ArrowRight' && idx < 5) {
        e.preventDefault();
        nextTick(() => authCodeInputs[idx + 1]?.focus());
    } else if (e.key === 'Backspace') {
    // Stay on current input, clear value
        if (authCode.value[idx]) {
            authCode.value[idx] = '';
            updateStoreAuthCode();
            e.preventDefault();
        }
    }
}

onMounted(async () => {
    await userStore.getAccountInfo();
    userStore.accountUpdateParams = { ...userStore.getEditAccountParams };
    await userStore.getCanDeleteAccount();

    await userStore.getCountries();
});

function sendResetPasswordRequest() {
    resetPasswordStore.resetPasswordForm.email = userStore.getAccountUpdateParams.email;
    resetPasswordStore.resetPassword();
}

async function deleteUser() {
    await userStore.deleteUser();
}

const v$ = useVuelidate({
    email: {
        required: helpers.withMessage('ERROR_REQUIRED', required),
        isValidEmail: helpers.withMessage('ERROR_EMAIL_INVALID', isValidEmail),
        minLength: minLength(1),
        maxLength: maxLength(255)
    }
}, userStore.emailChangeRequestParams);

async function sendAuthCode() {

    if (!await v$.value.$validate()) {
        return false;
    }

    // Clear all auth code fields
    authCode.value = ['', '', '', '', '', ''];
    updateStoreAuthCode();
    userStore.resetEmailChangeErrorMessages();
    
    if (await userStore.sendAuthCode()) {
        authCodeInputFadeIn();
    }
    return false;
}

async function verifyAuthCode()
{
    if (userStore.getEmailChangeParams.auth_code.length !== 6) {
        return false;
    }

    let authcodeCheck = $('.p-authcode-check__loading');
    authcodeCheck.addClass('is-loading');
    try {
        if (await userStore.verifyAuthCode()) {
            $('#modal-mailaddress').css({ display: 'none' });
            await userStore.getAccountInfo();
            sessionStore.session_data.email = userStore.editAccountParams.email;
            window.location.reload();
        }

    } catch (error) {
        throw error;
    } finally {
        authcodeCheck.removeClass('is-loading');
    }

}

function authCodeInputFadeIn()
{
    $('.p-modal-mailaddress__sender').css({ display: 'none' });
    $('.p-modal-mailaddress__authcode').fadeIn(400);
}

</script>